import { render, staticRenderFns } from "./singleReport.vue?vue&type=template&id=1b237eda&scoped=true"
import script from "./singleReport.vue?vue&type=script&lang=js"
export * from "./singleReport.vue?vue&type=script&lang=js"
import style0 from "./singleReport.vue?vue&type=style&index=0&id=1b237eda&prod&lang=less"
import style1 from "./singleReport.vue?vue&type=style&index=1&id=1b237eda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b237eda",
  null
  
)

export default component.exports